import { Group, useMantineTheme } from "@mantine/core";
import { DataGridPage, DataGridPageProps, GridColumnsOverrides } from "@mcurros2/microm";
import { IconAlertHexagonFilled, IconAlertTriangleFilled } from "@tabler/icons-react";
import { useMemo } from "react";

export interface ClientesConfiguracionPageProps extends DataGridPageProps {

}

export function ClientesConfiguracionPage(props: ClientesConfiguracionPageProps) {
    const { } = props;

    const theme = useMantineTheme();

    const configuracion = useMemo<GridColumnsOverrides>(() => ({
        // Servicios
        3: { render: (value: unknown) => (!value) ? <Group><IconAlertHexagonFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin servicios</Group> : value },
        // Cantidad de productos
        4: { render: (value: unknown) => (!value || value === '0') ? <Group><IconAlertHexagonFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin productos</Group> : value },
        // Cantidad de tiendas
        5: { render: (value: unknown) => (!value || value === '0') ? <Group><IconAlertHexagonFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin tiendas</Group> : value },
        // Cantidad de tiendas sin productos
        6: { render: (value: unknown) => (value && value !== '0') ? <Group><IconAlertTriangleFilled style={{ color: theme.colors.yellow[8] }} size="1.3rem" />{value as string}</Group> : '' },
        // Cantidad de tiendas sin servicios
        7: { render: (value: unknown) => (value && value !== '0') ? <Group><IconAlertTriangleFilled style={{ color: theme.colors.yellow[8] }} size="1.3rem" />{value as string}</Group> : '' },
    }), []);

    return (
        <DataGridPage
            {...props}
            enableAdd={false}
            enableDelete={false}
            columnsOverrides={configuracion}
        />
    );
}